// Approximate "unsaved changes" detection for the inline Form, which has no
// change tracking of its own. Pure so it can be unit tested.
const FIELD_TAGS = ['INPUT', 'SELECT', 'TEXTAREA'];
const BUTTON_INPUT_TYPES = ['button', 'submit', 'reset'];

export function isDirtyingEvent(target: EventTarget | null, type: string): boolean {
  if (!target) return false;
  const el = target as Element;
  if (type === 'change' || type === 'input') {
    const tag = typeof el.tagName === 'string' ? el.tagName.toUpperCase() : '';
    if (!FIELD_TAGS.includes(tag)) return false;
    if (tag === 'INPUT' && BUTTON_INPUT_TYPES.includes(String((el as HTMLInputElement).type || '').toLowerCase())) return false;
    return true;
  }
  if (type === 'click') {
    return typeof el.closest === 'function' && !!el.closest('[id*="-option-"]');
  }
  return false;
}
